// Constants
import {
  VORGANG_QES_UPDATED_FROM_SOCKET_EVENT,
  VORGANG_UPDATED_RECORD_ID_FROM_SOCKET_EVENT,
} from "../../../constants/socketConstants";

function getVorgangUpdatedIdFromSocketEvent(recordId) {
  // This action is dispatched when a socket event tells that manual request form record is updated and gives ID of that record
  return (dispatch) =>
    dispatch({
      type: VORGANG_UPDATED_RECORD_ID_FROM_SOCKET_EVENT,
      recordId,
    });
}

function getVorgangQESUpdatedFromSocketEvent(recordId) {
  // This action is dispatched when a socket event tells that QES is updated and gives ID of that record
  return (dispatch) =>
    dispatch({
      type: VORGANG_QES_UPDATED_FROM_SOCKET_EVENT,
      recordId,
    });
}

export const socketActions = {
  getVorgangUpdatedIdFromSocketEvent,
  getVorgangQESUpdatedFromSocketEvent,
};
